import firebase from 'firebase/app'
import 'firebase/firestore'
// import { FirebaseCommon } from './FirebaseCommon'
import Vue from 'vue'
import { ProductId } from "./Const"

// import { APIConnect } from "./APIConnect"
// import { Common } from "./common"
// import { SaleProductData } from "./SaleProductData"
// import config from 'config'

export default class CartManager {
    constructor() {
      this.cartList = [];
    }
    async update() {
      // カートデータを取得
      await this.getFBCartData();
    }

    async deleteAll(){
      await this.allDeleteFBCartData()
      this.cartList.splice(0);
    }

    async delete( tempId ) {
      await this.deleteFBCartData(tempId)
    }

    async deleteOption( productId ) {
      await this.deleteOptionFBCartData(productId)
    }

    async addCartProduct( productData, isSimple = false, progressCallback = function(progress){progress} ){
      // const isAcryl = [
      //   ProductId.S, ProductId.M, ProductId.L,
      //   ProductId.S_SVG, ProductId.M_SVG, ProductId.L_SVG,
      //   ProductId.S_SHARE, ProductId.M_SHARE, ProductId.L_SHARE
      // ].includes(productData.productId)
      // console.log(isAcryl)

      // この関数でZIPデータ保存、デザイン画像保存が一気にできる
      await productData.uploadDesignData(progressCallback);

      // このデータはオプション品もあることを考慮すること
      const cartData = {
        uid: firebase.auth().currentUser.uid,
        previewFilePath: productData.previewFilePath,
        designFilePath: productData.designFilePath,
        cutlineFilePath: productData.cutlineFilePath,
        tempId: productData.id,
        productId: productData.productId,
        quantity: productData.quantity,
        isShareCodeDraft: productData.isShareCodeDraft,
        isSimple: isSimple,
        title: "",
        acrylImageArray: productData.acrylFile,
        createDate: new Date(),
      }

      await this.addFBCartData(cartData);
      this.cartList.push(cartData);
    }

    async addCartOption( productId, title, num, imageUrl ){

      // すでにデータがあるかを調べる
      // オプションの場合はデータがある場合
      let data = this.cartList.filter(function(item){return item.productId == productId})
      console.log(data);

      if( data.length ){
        // データが存在する場合は更新
        let index = this.cartList.findIndex( item => item.productId == productId );
        let newNum = this.cartList[index].quantity + num;
        await this.updateFBOptionData( productId, newNum );

      }else{
        // データが存在しない場合は追加
        // このデータはオプション品もあることを考慮すること
        const cartData = {
          uid: firebase.auth().currentUser.uid,
          previewFilePath: imageUrl,
          cutlineImagePath: "",
          tempId: "",
          productId: productId,
          quantity: num,
          isShareCodeDraft: "",
          isSimple: "",
          title: title,
          createDate: new Date(),
        }

        await this.addFBCartData(cartData);
        this.cartList.push(cartData);
      }
    }

    async addCartAcryPrint( productData, progressCallback = function(progress){progress} ){

      // この関数でZIPデータ保存、デザイン画像保存が一気にできる
      await productData.uploadDesignData(progressCallback);

      // このデータはオプション品もあることを考慮すること
      const cartData = {
        uid: firebase.auth().currentUser.uid,
        previewFilePath: productData.previewFilePath,
        designFilePath: productData.designFilePath,
        cutlineFilePath: productData.cutlineFilePath,
        tempId: productData.id,
        productId: productData.productId,
        quantity: productData.quantity,
        isShareCodeDraft: productData.isShareCodeDraft,
        isSimple: false,
        title: "",
        acrylImageArray: productData.acrylFile,
        createDate: new Date(),
      }

      await this.addFBCartData(cartData);
      this.cartList.push(cartData);
    }


    async getFBCartData(){
      const ref = firebase.firestore().collection("AcryProCart");
      const snapshot = await ref.where("uid", "==", firebase.auth().currentUser.uid).get();
      this.cartList.splice(0);

      for( let i = 0; i<snapshot.docs.length; ++i ){
        const data = snapshot.docs[i].data();
        console.log(data);
        const obj =
          {
            uid: data.uid,
            previewFilePath: data.previewFilePath,
            // zipPath: data.zipPath,
            tempId: data.tempId,
            productId: data.productId,
            quantity: data.quantity,
            isShareCodeDraft: data.isShareCodeDraft,
            isSimple: data.isSimple,
            title: data.title,
            createDate: data.createDate,
          };
          if( "acrylImageArray" in data ){ // アクリルデータは追加で
            obj.designFilePath = data.designFilePath;
            obj.cutlineFilePath = data.cutlineFilePath;
            obj.acrylFile = data.acrylImageArray;
          }
          // Vue.set(this.cartList, i, obj);
          this.cartList.push(obj);
      }
    }

    getCartList(){
      return this.cartList
    }

    // 指定のプロダクトと同じ種別の商品の個数がいくつカートに含まれるか
    getCartProductQuantity( productId ){
      // 通常のアクリルとAcryPrintのサイズごとの数量を計算
      let quantity = { s: 0, m: 0, l: 0, ap_s: 0, ap_m: 0, ap_l: 0 }

      this.cartList.forEach(item => {
        if( [ProductId.S_SVG, ProductId.S_SHARE].includes(item.productId) ){
          quantity.s += parseInt(item.quantity);
        }
        if( [ProductId.M_SVG, ProductId.M_SHARE].includes(item.productId) ){
          quantity.m += parseInt(item.quantity);
        }
        if( [ProductId.L_SVG, ProductId.L_SHARE].includes(item.productId) ){
          quantity.l += parseInt(item.quantity);
        }
        if( [ProductId.ACRY_PRINT_S].includes(item.productId) ){
          quantity.ap_s += parseInt(item.quantity);
        }
        if( [ProductId.ACRY_PRINT_M].includes(item.productId) ){
          quantity.ap_m += parseInt(item.quantity);
        }
        if( [ProductId.ACRY_PRINT_L].includes(item.productId) ){
          quantity.ap_l += parseInt(item.quantity);
        }
      });

      if( [ProductId.S_SVG, ProductId.S_SHARE].includes(productId) ){
        return quantity.s;
      }
      if( [ProductId.M_SVG, ProductId.M_SHARE].includes(productId) ){
        return quantity.m;
      }
      if( [ProductId.L_SVG, ProductId.L_SHARE].includes(productId) ){
        return quantity.l;
      }
      if( [ProductId.ACRY_PRINT_S].includes(productId) ){
        return quantity.ap_s;
      }
      if( [ProductId.ACRY_PRINT_M].includes(productId) ){
        return quantity.ap_m;
      }
      if( [ProductId.ACRY_PRINT_L].includes(productId) ){
        return quantity.ap_l;
      }

      return 0;
    }

    async addFBCartData(data){
      await firebase.firestore().collection("AcryProCart").add(data);
    }

    async deleteFBCartData( tempId ){
      const ref = firebase.firestore().collection("AcryProCart");
      const snapshot = await ref.where("uid", "==", firebase.auth().currentUser.uid).where("tempId", "==", tempId).get();
      for( const doc of snapshot.docs ){
        await firebase.firestore().collection("AcryProCart").doc(doc.id).delete().then(() => {
          const index = this.cartList.findIndex( item => item.tempId == tempId );
          this.cartList.splice(index, 1);
        }).catch((error) => {
            console.error("Error removing document: ", error);
        });
      }
    }

    async deleteOptionFBCartData( productId ){
      const ref = firebase.firestore().collection("AcryProCart");
      const snapshot = await ref.where("uid", "==", firebase.auth().currentUser.uid).where("productId", "==", productId).get();
      for( const doc of snapshot.docs ){
        await firebase.firestore().collection("AcryProCart").doc(doc.id).delete().then(() => {
          const index = this.cartList.findIndex( item => item.productId == productId );
          this.cartList.splice(index, 1);
        }).catch((error) => {
            console.error("Error removing document: ", error);
        });
      }
    }

    async allDeleteFBCartData(){
      const ref = firebase.firestore().collection("AcryProCart");
      const snapshot = await ref.where("uid", "==", firebase.auth().currentUser.uid).get();
      for( const doc of snapshot.docs ){
        await firebase.firestore().collection("AcryProCart").doc(doc.id).delete().then(() => {
          console.log("Document successfully deleted!");
        }).catch((error) => {
            console.error("Error removing document: ", error);
        });
      }
    }

    async updateFBOptionData(productId, newNum){
      const ref = firebase.firestore().collection("AcryProCart");
      const snapshot = await ref.where("uid", "==", firebase.auth().currentUser.uid).where("productId", "==", productId).get();
      if( snapshot.docs[0] ){
        let doc = snapshot.docs[0];
        await firebase.firestore().collection("AcryProCart").doc(doc.id).update(
            {
              quantity: newNum
            }
          ).then(() => {
            let index = this.cartList.findIndex( item => item.productId == productId );
            this.cartList[index].quantity = newNum;
            Vue.set(this.cartList);
          }).catch((error) => {
            console.error("Error removing document: ", error);
        });
      }else{
        console.error("カートに存在しないProductId");
      }
    }

}
export { CartManager }